import { BaseDto } from '../../core';
import { MapperSaleProduct } from '../product/mapper-sale-product.entity';
import { PRODUCT_STATUS, PRODUCT_SHIPPING_TYPE, APPROVED_STATUS } from '../../shared';
import { BuyerCoupon } from '..';

export class Cart extends BaseDto<Cart> {
  id: number;
  checked: boolean;
  buyerId: number;
  mapperSaleProductId: number;
  quantity: number;
  shippingType: PRODUCT_SHIPPING_TYPE;
  // created: Date;
  // updated: Date;
  totalSalePriceUSD?: number;
  totalWeight?: number;
  mapperSaleProduct?: MapperSaleProduct;

  hasQuantityMinError: boolean;
  hasQuantityMaxError: boolean;
  totalQuanityError: boolean;
  hasInboxError: boolean;
  hasStockError: boolean;
  hasError: boolean;
  buyerCoupons?: BuyerCoupon[];

  isUsable() {
    if (
      this.mapperSaleProduct &&
      this.mapperSaleProduct.product &&
      this.mapperSaleProduct.productOption &&
      this.mapperSaleProduct.product.productStatus === PRODUCT_STATUS.APPROVAL &&
      this.mapperSaleProduct.productOption.productStatus === PRODUCT_STATUS.APPROVAL &&
      this.mapperSaleProduct.productOption.brand.approvedStatus === APPROVED_STATUS.APPROVAL
    ) {
      return true;
    }
  }

  isOutOfStock() {
    if (
      this.mapperSaleProduct &&
      this.mapperSaleProduct.product &&
      this.mapperSaleProduct.productOption &&
      (this.mapperSaleProduct.product.productStatus === PRODUCT_STATUS.OUT_OF_STOCK ||
        this.mapperSaleProduct.productOption.productStatus === PRODUCT_STATUS.OUT_OF_STOCK)
    ) {
      return true;
    }
  }

  isNotUsable() {
    return !this.isUsable() && !this.isOutOfStock();
  }

  isLessQuantity() {
    return (
      this.mapperSaleProduct.productOption.stock !== undefined &&
      this.mapperSaleProduct.productOption.stock !== null &&
      this.mapperSaleProduct.productOption.stock < this.quantity &&
      this.mapperSaleProduct.productOption.rocketStock === null
    );
  }
}
